<template>
    <table  class="table table-sm table-borderless attack-table">
        <thead class="thead-dark">
            <tr><th :title="this.nameTitle" :style="nameFontSize" colspan="2">{{this.attack.name}} <strong>{{this.attack.power}}</strong></th></tr>
        </thead>
        <tbody>
        <tr>
            <th title="Damage per hit/Damage per turn">DMG</th><td>{{this.attack.damage}}/{{this.dpt}}</td>
        </tr>
        <tr>
            <th title="Needed hits to defeat opponent">Hits</th><td>{{this.attack.hits}}</td>
        </tr>
        <tr>
            <th data-toggle="tooltip" data-placement="top" title="Energy gain">E-gain</th><td class="f-smaller">{{this.attack.energyGain}}/{{this.attack.energyDelta}}</td>
        </tr>
<!--        <tr>-->
<!--            <th>EDelta</th><td>{{this.attack.energyDelta}}</td>-->
<!--        </tr>-->
        <tr v-if="this.attack.chargeTime > 0">
            <th title="Charging time">Charge</th><td>{{this.attack.chargeTime}}&thinsp;s</td>
        </tr>
        <tr v-if="this.attack.tapsToCharge > 0">
            <th>Taps</th><td>{{Math.ceil(this.attack.tapsToCharge)}}×</td>
        </tr>
        <tr  v-if="this.attack.posibleUses > 0">
            <th>Use</th><td>{{Math.ceil(this.attack.posibleUses)}}×</td>
        </tr>
        <tr  v-if="this.attack.posibleUses > 0">
            <th>Tot.Taps</th><td>{{Math.ceil(this.attack.posibleUses*this.attack.tapsToCharge)}}×</td>
        </tr>
        <tr  v-if="this.attack.hp_left_first > 0 || this.attack.hp_left_with_shield_first > 0">
            <th>1.Use</th><td class="f-small">{{Math.ceil(this.attack.hp_left_first)}}/{{Math.ceil(this.attack.hp_left_with_shield_first)}} HP ({{this.attack.time_after_first }}s)</td>
        </tr>
        <tr  v-if="this.attack.hp_left_second > 0 || this.attack.hp_left_with_shield_second > 0">
            <th>2.Use</th><td class="f-small">{{Math.ceil(this.attack.hp_left_second)}}/{{Math.ceil(this.attack.hp_left_with_shield_second)}} HP ({{this.attack.time_after_second}}s)</td>
        </tr>
        <tr  v-if="this.attack.hp_left_third > 0 || this.attack.hp_left_with_shield_third > 0">
            <th>3.Use</th><td class="f-small">{{Math.ceil(this.attack.hp_left_third)}}/{{Math.ceil(this.attack.hp_left_with_shield_third)}} HP ({{this.attack.time_after_third }}s)</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: "AttackInfo",
        props:['attack','energy'],
        methods:{},
        computed:{
            nameFontSize:function () {
               let length = this.attack.name.length;
               let power = this.attack.power.toFixed(0).length;
               if((length+power)<12){
                   return "font-size:1rem"
               }else if((length+power)<15){
                   return "font-size:0.80rem"
               }else if((length+power)<18){
                   return "font-size:0.70rem"
               }else{
                   return "font-size:0.5rem"
               }
            },
            dpt: function () {
                let turns = this.attack.duration/500;
                return Math.round(this.attack.damage/turns*10)/10
            },
            nameTitle:function () {
               return this.attack.name+" Power:"+this.attack.power + " Turns:" + (this.attack.duration/500)+'';
            }
        },
        // beforeMount() {
        //     console.log(typeof this.attack);
        // }
    }
</script>

<style scoped lang="less">
    .attack-table{
        min-width: 7.7em;
        max-width: 9em;
        /*margin-left: -6px;!* !important;*!*/
        margin-left: 1px;/* !important;*/
        margin-right: 1px;/* !important;*/
        tr {
            line-height: 0.9rem;
        }
    }
    .f-small{
        font-size:0.82rem
    }
    .f-smaller{
        font-size:0.70rem
    }
    .f-smallest{
        font-size:0.50rem
    }
</style>